import states from '../lib/states'
import types from './types'

let currentId = 0

let forceInstructions = localStorage.getItem('first_visit') !== undefined && localStorage.getItem('first_visit') !== null
  ? JSON.parse(localStorage.getItem('first_visit'))
  : true

let defaultState = {
  status: states.UNDEFINED,
  duration: undefined,
  position: undefined,
  isOffsetViewOn: false,
  minimized: localStorage.getItem('minimized') !== undefined && localStorage.getItem('minimized') !== null && forceInstructions === false
    ? JSON.parse(localStorage.getItem('minimized'))
    : !forceInstructions,
  offset: 0
}

const reducers = (state = defaultState, action) => {
  switch (action.type) {
  case types.CLEAR_SONG:
    return {
      ...state,
      song: undefined
    }

  case types.DECREMENT_OFFSET:
    return {
      ...state,
      offset: state.offset - 10
    }

  case types.INCREMENT_OFFSET:
    return {
      ...state,
      offset: state.offset + 10
    }

  case types.INCREMENT_TIMER:
    return {
      ...state,
      position: state.position + 1
    }

  case types.RESET_TIMER:
    return {
      ...state,
      position: undefined,
      duration: undefined
    }

  case types.SET_OFFSET:
    if (action.offset !== state.offset) {
      return {
        ...state,
        offset: action.offset
      }
    }
    return state

  case types.START_TIMER:
    return {
      ...state,
      position: action.position,
      duration: action.duration
    }

  case types.TOGGLE_MINIMIZED_APP:
    if (forceInstructions === false) {
      localStorage.setItem('minimized', !state.minimized)
    }
    return {
      ...state,
      minimized: !state.minimized
    }

  case types.TOGGLE_OFFSET_VIEW:
    return {
      ...state,
      isOffsetViewOn: !state.isOffsetViewOn
    }

  case types.UPDATE_STATUS:
    return {
      ...state,
      status: action.status
    }

  case types.UPDATE_SONG:
    if (
      action.song &&
      action.song.title &&
      action.song.artist
    ) {
      currentId = (currentId + 1) % Number.MAX_SAFE_INTEGER
      action.song.id = currentId
      return {
        ...state,
        status: action.status,
        song: action.song
      }
    } else {
      return {
        ...state,
        status: action.status
      }
    }

  case types.GET_STATE:
  case types.PLAYER_STOP:
  case types.STOP_TIMER:
  default:
    return state
  }
}

export default reducers



// WEBPACK FOOTER //
// ./src/duck/reducers.js